import React from 'react';
import { ArcDroneMarker } from '@src/core/controllers';
import { FlightDroneProps } from './types';

const FlightDrone: React.FC<FlightDroneProps> = (props) => {
  const { drone, rotation } = props;

  const droneLat = Number(drone?.latitude);
  const droneLng = Number(drone?.longitude);

  return (
    <ArcDroneMarker.missionArrow 
      position={{ 
        lat: droneLat ,
        lng: droneLng 
      }} 
      rotation={rotation}
    />
  );
};

export default FlightDrone;